import React from 'react';

import styles from './DrawerFooter.scss';

type Props = {
  children?: React.ReactNode;
};

function DrawerFooter(props: Props) {
  const { children } = props;

  return <div className={styles.footer}>{children}</div>;
}

export default React.memo(DrawerFooter);
